module.exports = __webpack_public_path__ + "img/kjrc-cyds.c693d74e.jpg";